export default {"src":"/web-pdp-scaffold-ui/_next/static/media/anyday.9f43e1a8.svg","height":17,"width":109,"blurWidth":0,"blurHeight":0};